import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const APP_NAME = "Weave";

const siteSlugFromPath = (pathname) => {
  const raw = pathname.match(/^\/site\/([^/]+)\//)?.[1];
  const reserved = new Set([
    "preview", "data", "templates", "changes", "change-requests", "deployments", "deploys", "settings", "analytics", "seo",
  ]);
  return raw && !reserved.has(raw) ? raw : null;
};

const DocumentTitle = ({ title }) => {
  const location = useLocation();
  const { projects } = useSelector((state) => state.project);
  const siteSlug = siteSlugFromPath(location.pathname);
  const siteName = siteSlug
    ? projects.find((project) => project.slug === siteSlug || project.hash === siteSlug)?.name
    : null;

  useEffect(() => {
    const parts = [siteName, title, APP_NAME].filter(Boolean);
    document.title = parts.join(" · ");
  }, [siteName, title]);

  return null;
};

export default DocumentTitle;
